import request from '@/utils/request';

export default {

    state:{
        //找回密码(用户名)：
        editUserName:'',
    
        isavatar:false,
        avatar:'',
        isCollapse: false ,
        white808S :[],
        black808S :[],
        cl4S :[],
        cl4FaceS :[],
        machineID:'',
        userID :'',
        default_active :'0',
        white808UserID :0,
        cl4UserID :0,
        black808UserID:0,
        cls_gender :0,

        cl4FaceUserID:0,
        cl4Face_gender:0,


        tabsList:[
            {
                name:'home',
                pageFlag:0,
                machine:'',
                model:'',
                path:'/home'
            }
        ]
    },
    mutations:{
        getWhite808Position(state,machineID){
            for (let i = 0; i < state.white808S.length; i++) {
                const item = state.white808S[i];
                if(state.white808S[i].machine==machineID){
                    state.default_active =state.white808S[i].id;
                    break;
                }
            }
        },
        getBlack808Position(state,machineID){
            for (let i = 0; i < state.black808S.length; i++) {
                const item = state.black808S[i];
                if(state.black808S[i].machine==machineID){
                    state.default_active =state.black808S[i].id;
                    break;
                }
            }
        },
        getClsPosition(state,machineID){
            for (let i = 0; i < state.cl4S.length; i++) {
                const item = state.cl4S[i];
                if(state.cl4S[i].machine==machineID){
                    state.default_active =state.cl4S[i].id;
                    break;
                }
            }
        },
        getCl4FacePosition(state,machineID){
            for(let i =0; i<state.cl4FaceS.length;i++){
                const item = state.cl4FaceS[i];
                if(state.cl4FaceS[i].machine == machineID){
                    console.log("machind id " + state.cl4FaceS[i].id)
                    state.default_active = state.cl4FaceS[i].id;
                    break;
                }
            }
        },
        collapseMenu(state){
            state.isCollapse = !state.isCollapse
        },
        setWhite808S(state, data) {
            state.white808S = data;
        },
        setBlack808S(state, data) {
            state.black808S = data;
        },
        setCl4S(state, data) {
            state.cl4S = data;
        },
        setCl4FaceS(state,data) {
            state.cl4FaceS = data;
        },
        clearTabsListExceptFirst(state) {
            state.tabsList = state.tabsList.slice(0, 1); // 保留第一项
        },
        updateSecondTab(state, data) {
            state.tabsList.push(data); // 如果只有第一项，则添加为第二项
        }
    },
    actions: {
        getMachineID({ commit }, payload) {
            request.get("/user/selectMachineID",{
                params:{
                    model : payload.mode,
                    userID :payload.userID
                }
            }).then(res=>{
                if(payload.mode ==='white808'){
                    commit('setWhite808S', res.data);
                }else if(payload.mode == 'black808'){
                    commit('setBlack808S', res.data);
                }else if(payload.mode == 'cl4'){
                    commit('setCl4S', res.data);
                }else if(payload.mode =='cl4Face'){
                    console.log('cl4Face is '+ res.data)
                    commit('setCl4FaceS',res.data)
                }
            }).catch(error => {
                console.error('Error fetching data:', error);
            });
        },
    }
}